export const SET_BROKER_LOAN_APPLICATION_SUCCESS =
  'SET_BROKER_LOAN_APPLICATION_SUCCESS'
export const SET_BROKER_LOAN_APPLICATION_REQUEST =
  'SET_BROKER_LOAN_APPLICATION_REQUEST'
export const SET_BROKER_LOAN_APPLICATION_FAILURE =
  'SET_BROKER_LOAN_APPLICATION_FAILURE'
